import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class MockService {
    private mockList: Map<string, string | {}> = new Map();

    constructor(private http: HttpClient) {}

    // this.addMock('/proxy/v1/voice/v1/wiki/6239/de_de', '/assets/mocks/json/substance-6239.jsn');
    // this.addMock('/proxy/v1/configuration/v3/config/en_global', '/assets/mocks/json/config-en_global.jsn');
    public addMock(urlPath: string, fileContent: string | object | Array<any>) {
        this.mockList.set(urlPath, fileContent);
    }

    public getData<T>(path: string): Promise<T> {
        const _mockContent = this.mockList.get(path);
        if (typeof _mockContent === 'string') {
            return this.http.get<T>(<string>_mockContent).toPromise();
        } else {
            return Promise.resolve(<T>_mockContent);
        }
    }

    public isActive(path: string): boolean {
        return this.mockList.has(path);
    }

    public getCourses() {
        let courses = [
            {
                id: '1336',
                name: '1e Monteur',
                date_created: '2020-01-24T08:30:56.000',
                training: {
                    id: '2996',
                    code: 'Kwaliteitslasser',
                    name: 'Kwaliteitslasser',
                    description: 'Instructie die gevolgd moet worden alvorens de werkvloer op te gaan<br />\r\n       ',
                    description_short: "'s avonds",
                    date_created: '2020-01-24T08:30:56.000',
                    digital: false,
                    visible: true
                }
            },
            {
                id: '13356',
                name: '1e Monteur',
                date_created: '2020-01-24T08:30:56.000',
                training: {
                    id: '2996',
                    code: 'Kwaliteitslasser',
                    name: 'Kwaliteitslasser',
                    date_created: '2020-01-24T08:30:56.000',
                    description: 'Instructie die gevolgd moet worden alvorens de werkvloer op te gaan<br />\r\n       ',
                    description_short: "'s avonds",
                    digital: false,
                    visible: true
                }
            }
        ];

        return courses;
    }
    // public getCourses() {
    //     let courses = [
    //         {
    //           'id': 1,
    //           'title': "Safe Entry into Confined Spaces CSE",
    //           'shortDesc': 'Lorem ipsum dolor sit amet',
    //           'objectives': 'This training course aims to assess the participants in the skills and knowledge required to carry out air purity tests. By completing this course it is expected that participants will have the necessary knowledge to select the appropriate equipment required and carry out air quality checks.',
    //           'location': 'Blyth, Northumberland  ',
    //           'dates': ['20.Oct 2020, 09.00 - 20.Oct 2020, 16.30', '21.Oct 2020, 09.00 - 21.Oct 2020, 16.30']
    //         },
    //         {
    //           'id': 2,
    //           'title': "Breathing Apparatus",
    //           'shortDesc': 'Within this training series you`ll find topics including Breathing Apparatus Care & Maintenance, Breathing Apparatus Wearing, Donning & Monthly Inspection',
    //           'objectives': 'This training course aims to assess the participants in the skills and knowledge required to carry out air purity tests. By completing this course it is expected that participants will have the necessary knowledge to select the appropriate equipment required and carry out air quality checks.',
    //           'location': 'Blyth, Northumberland  ',
    //           'dates': [`20.Oct 2020, 09.00 - 20.Oct 2020, 16.30`]
    //         },
    //         {
    //           'id': 3,
    //           'title': "Safe Entry into Confined Spaces CSE",
    //           'shortDesc': 'Lorem ipsum dolor sit amet',
    //           'objectives': 'This training course aims to assess the participants in the skills and knowledge required to carry out air purity tests. By completing this course it is expected that participants will have the necessary knowledge to select the appropriate equipment required and carry out air quality checks.',
    //           'location': 'Blyth, Northumberland  ',
    //           'dates': ['20.Oct 2020, 09.00 - 20.Oct 2020, 16.30', '21.Oct 2020, 09.00 - 21.Oct 2020, 16.30']
    //         },
    //         {
    //           'id': 4,
    //           'title': "Gas Detection",
    //           'shortDesc': 'Within this training series you`ll find topics including Advanced Gas Detection Use & Calibration, Gas Detection X-Dock User, Gas Detection Area Monitoring System, Basic Gas Detection & Appreciation, Basic Gas Detection Using Tube Systems , OPITO H2S training, Fixed Gas Detection Use, Maintenance & Calibration and Fixed Gas Detection Use & Configuration.',
    //           'objectives': 'This training course aims to assess the participants in the skills and knowledge required to carry out air purity tests. By completing this course it is expected that participants will have the necessary knowledge to select the appropriate equipment required and carry out air quality checks.',
    //           'location': 'Blyth, Northumberland  ',
    //           'dates': ['20.Oct 2020, 09.00 - 20.Oct 2020, 16.30', '21.Oct 2020, 09.00 - 21.Oct 2020, 16.30']
    //         },
    //         {
    //           'id': 5,
    //           'title': "Safe Entry into Confined Spaces CSE",
    //           'shortDesc': 'Lorem ipsum dolor sit amet',
    //           'objectives': 'This training course aims to assess the participants in the skills and knowledge required to carry out air purity tests. By completing this course it is expected that participants will have the necessary knowledge to select the appropriate equipment required and carry out air quality checks.',
    //           'location': 'Blyth, Northumberland  ',
    //           'dates': ['20.Oct 2020, 09.00 - 20.Oct 2020, 16.30', '21.Oct 2020, 09.00 - 21.Oct 2020, 16.30']
    //         },
    //       ];

    //     return courses;
    // }
}
